import { Aggregated_Audience_Operator } from '@occc/graphql';

import { combinedAudiencesInitialValues } from './constants';

import { CombinedAudiencesAttribute } from '../../types';

export const getCombinedAudiencesInitialFormValues = (
  combinedAudiencesAttribute: CombinedAudiencesAttribute | null,
) => {
  if (!combinedAudiencesAttribute) {
    return combinedAudiencesInitialValues;
  }

  return {
    audiences: combinedAudiencesAttribute.audiences,
    operator: combinedAudiencesAttribute.operator ?? Aggregated_Audience_Operator.InAll,
  };
};
